var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import styled, { css } from "styled-components";
import Column from "./Column";
/**
 * Used to keep track of the number of overlays open that need the body scrollbars hidden.
 * When this number drops to `0`, the body scroll styles are reset to allow scrolling.
 */
let hideBodyScrollbarCount = 0;
const Overlay = props => {
    const { inRoot = true } = props, rest = __rest(props, ["inRoot"]);
    const [offset, setOffset] = useState(0);
    useEffect(() => {
        if (inRoot) {
            const scrollingElement = document.scrollingElement || document.body;
            hideBodyScrollbarCount += 1;
            document.body.style.overflowX = "hidden";
            document.body.style.overflowY = "hidden";
            setOffset(scrollingElement.scrollTop);
            return () => {
                hideBodyScrollbarCount = Math.max(0, hideBodyScrollbarCount - 1);
                if (hideBodyScrollbarCount === 0) {
                    document.body.style.overflowX = "hidden";
                    document.body.style.overflowY = "auto";
                }
            };
        }
        return;
    }, [inRoot]);
    if (inRoot) {
        return ReactDOM.createPortal(React.createElement(Column, Object.assign({}, rest, { style: { top: Math.max(0, offset - 1) }, "data-overlay": true })), document.body);
    }
    else {
        return React.createElement(Column, Object.assign({}, rest, { "data-overlay": true }));
    }
};
export function isOverlay(target) {
    return target && target.dataset && target.dataset.overlay;
}
export default styled(Overlay) `
  left: 0;
  top: 0;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 100;

  ${props => {
    const position = props.inRoot ? "absolute" : "absolute";
    return props.inRoot
        ? css `
          position: ${position};
          width: 100vw;
          height: 100vh;
        `
        : css `
          position: ${position};
          width: 100%;
          height: 100%;
        `;
}}
`;
